<template>
  <f7-page>
  </f7-page>
</template>

<script>
  import {errorMessageAlert} from '@/helpers/alert'
  import Spinner from '@/components/common/spinner'
  import {loadPage} from '@/helpers/routing'

  export default {
    name: 'RedirectionPageOTP',
    props: ['email', 'otp', 'ressource'],
    components: {
      'spinner': Spinner
    },
    data: () => {
      return {
        details: undefined
      }
    },
    created () {
      let that = this
      this.logInWithOTP(this.email, this.otp)
        .then((response) => {
          that.getDirectDebit(that.ressource)
        })
        .then((response) => {
          // In case the redirection fails, retry in 1 second
          console.log(response)
          setTimeout(function () {
            that.loadDirectDebitDetailsPage(response.data.directDebits[0], true)
          }, 1000)
        })
    },
    methods: {
      /**
       * Log in to MoneyRoad with an otp
       * @param {{email: String}} - of the user to log
       * @param {{otp: String}} - one time password of the user to log
       *
       * @return Promise
       */
      logInWithOTP (email, otp) {
        let that = this
        this.$f7.showPreloader('Connecting to MoneyRoad')
        return this.$engine.auth.loginOTP({ email: email, otp: otp })
          .then(resp => {
            that.details = {}
            if (resp.status === 200) {
              this.$f7.hidePreloader()
              this.initMoneyRoadMenus()
              let connectedModal = this.$f7.modal({
                title: 'Connected to MoneyRoad as guest (' + email + ')',
                text: 'Redirecting to ressource.'
              })
              setTimeout(function () {
                that.$f7.closeModal(connectedModal)
              }, 2000)
              return resp
            } else {
              this.failed(new Error('OTP expired'), 'Connection failed', 'Your OTP password is expired', [
                {
                  text: 'Email me a new OTP code.',
                  onClick: function () {
                    // console.log('TODO: send an email with a new OTP')
                  }
                }
              ])
            }
          })
          .catch(err => {
            this.failed(err, 'Failed to connect with OTP', '', [
              {
                text: 'Close',
                onClick: function () {
                  that.$bus.$emit('otp-expired')
                  that.$engine.user.unload()
                  loadPage(that, { url: '/login/' })
                }
              }
            ])
            errorMessageAlert(err, that)
          })
      },
      /**
       * Get the directDebit by it's notification code
       * As of 11/08/2020 this returns only directDebit of direction 0 !
       * @param {{ressource: String}} - coressponds to cm_moneyroad.notification_instance.code
       *
       * @return Promise
       */
      getDirectDebit (ressource) {
        let that = this
        return that.$engine.services.directDebit.update(0, 10, 1, undefined, ressource)
          .then(resp => {
            setTimeout(function () {
              that.loadDirectDebitDetailsPage(resp.data.directDebits[0], true)
            }, 1000)
            return resp
          })
          .catch(err => {
            this.failed(err, 'Failed to retrieve ressource')
          })
      },
      /**
       * Changes page to directDebit/details
       * @param {{message: String}} - coressponds to the directDebit id
       * @param {{isReceived: String}} - always true (dont ask)
       *
       * @return Promise
       */
      loadDirectDebitDetailsPage (message, isReceived) {
        let that = this
        this.loadDirectDebitDetailsPageSetEngineParams(message, isReceived)
        return this.$engine.services.directDebit.notificationRead(this.ressource)
          .then(resp => {
            this.$bus.$emit('LogIn', true)
            loadPage(that, {url: that.loadDirectDebitDetailsPageGetUrl(message.direction)})
            return resp
          })
          .catch(err => {
            console.error('Failed to set notification read')
            throw err
          })
      },
      /**
       * Sets parameters required by the engine to loadPage directDebit/details
       * @param {{message: String}} - coressponds to the directDebit id
       * @param {{isReceived: String}} - always true (dont ask)
       */
      loadDirectDebitDetailsPageSetEngineParams (message, isReceived) {
        this.$engine.user.currentService.id = '2'
        if (this.$engine.user.currentService.id === '2') {
          this.$engine.settings.set({clickedMessage: message})
          this.$engine.settings.set({msgFromInbox: isReceived})
        }
        if (message.direction === '0') {
          if (this.$engine.user.currentService.id === '2') {
            this.$engine.services.directDebit.currentInbox = message
          }
          if (this.$engine.user.currentService.id === '6') {
            this.$engine.services.directPayments.currentInbox = message
          }
        // Guest account cannot send messages therefore he has no sendbox
        // } else {
        //   if (this.$engine.user.currentService.id === '2') {
        //     that.$engine.services.directDebit.currentSendbox = message
        //   }
        //   if (this.$engine.user.currentService.id === '6') {
        //     that.$engine.services.directPayments.currentSendbox = message
        //   }
        }
      },
      /**
       * Get the url from the engine to loadPage directDebit/details
       * @param {{message: String}} - coressponds to the directDebit id
       * @param {{isReceived: String}} - always true (dont ask)
       *
       * @return redirection url
       */
      loadDirectDebitDetailsPageGetUrl (direction) {
        let redirectionUrl = {
          '1': '/payments/transaction-details/',
          '2': '/directDebit/details/',
          '6': '/directPayments/details/'
        }
        return redirectionUrl[this.$engine.user.currentService.id] + direction + '/'
      },
      /**
       * Shows an error modal to the user and throws the error in js
       * @param {{error: Error}} - error to be thrown
       * @param {{title: String}} - Title of the modal
       * @param {{description: String}} - Description of the modal
       * @param {{buttons: Array}} - Buttons of the modal (check the method logInWithOTP for an example or the f7 documentation about modals)
       *
       * @throws error
       */
      failed (error, title, description = '', buttons = []) {
        this.$f7.hidePreloader()
        this.$f7.modal({
          title: title,
          text: description,
          verticalButtons: true,
          buttons: buttons
        })
        throw error
      },
      /**
       * Initializes MoneyRoad menus for Direct Debit
       */
      initMoneyRoadMenus () {
        this.$bus.emit('LogIn', true)
        this.$bus.emit('refresh-cache-menu')
        this.$engine.user.changeService(this.$engine.services.get()[1]) // Direct Debit
        this.$bus.emit('service:change', 'Direct Debit')
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// RedirectionPageOTP.vue?ac19546e